module.exports = __webpack_public_path__ + "img/hr-brown-fluff-08.b2af9706.png";